import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import {
  OrderDocumentSendRequestType,
  OrderDocumentSendResponseType,
} from "@sellar-io/api-v2/types";

export const useOrderDocumentSend = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OrderDocumentSendRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `order-documents/send`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<OrderDocumentSendResponseType>(response).data,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.OrderDocument],
      });
    },
  });
};
